// Module
var code = `<div class="additional-verification-screen-container {{'step-' + currentStep}}">
    {{#if currentStep === GoogleAuthenticator.StepGoogleAuthRequest}}
    <div class="step-two-middle-part"> 
        
        <div class="qr-code-section">
            {{#if isQRCodeLoaded}}
                <img src="{{.srcOfQRCode}}" alt="QR Code" class="qr-code" width="154" height="154" />
            {{else}}
                <div class="spinner"></div>
            {{/if}}
        </div>
    </div>

    <div class="js-input-GoogleAuth-SecretKeyArea">
        <terceraLabel text="{{secretKeyLabel}}" additionalClass="js-tercera-label-transparentBG" name="forGoogleAuthSecretKeyTextBoxTheRealOne" />
        <passwordTextBox name="GoogleAuthSecretKeyTextBox" showPasswordPreview="true" text="{{secretKeyText}}"
            elementStyle="js-input-GoogleAuth-SecretKey" />
        <terceraButton name="copyButton" tooltip="{{passwordHided ? showPassEyeTooltip : hidePassEyeCrossedTooltip}}"
            terceraButtonStyle="copy-btn-container" SVG="true" on-btnClick="@this.copyBtnClick()" />
    </div>

    <div class="instructions">
        {{secondStepText}}
    </div>
    {{/if}}

    {{#if currentStep === GoogleAuthenticator.StepsCount}}
    <div class="step-three">
        <div class="enterCodeLabel">{{userCodeLabel}}</div>

        <digitInput 
            value="{{userCodeText}}" 
            hasError="{{haveError}}" 
            autofocus="true" 
            on-valueChanged="@this.set('userCodeText', \$2)"
        />

        {{#if haveError}}<div class="errorText">{{errorText}}</div>{{/if}}
        <div class="instructions">{{thirdStepText}}</div>
    </div>
    {{/if}}

    <!-- Footer -->
    <div class="additional-verification-screen-footer">
        <!-- Back button -->
        {{#if @this.backBtnVisible()}}
        <terceraButton name="ArrowLeft" SVG="true"
            terceraButtonStyle="back-button"  
            text="{{backText}}" 
            on-btnClick="@this.backClick()"
        />
        {{/if}}

        <!-- Next button -->
        {{#if @this.nextBtnVisible()}}
        <terceraButton name="ArrowRight" SVG="true"
            terceraButtonStyle="next-button"  
            text="{{nextText}}" 
            on-btnClick="@this.nextClick()"
        />
        {{/if}}

        <!-- Finish button -->
        {{#if @this.finishBtnVisible()}}
        <terceraButton
            terceraButtonStyle="next-button"  
            text="{{finishText}}" 
            on-btnClick="@this.finishClick()"
        />
        {{/if}}
    </div>
</div>`;
// Exports
export default code;